export default "__VITE_PUBLIC_ASSET__978c7e06__"